<template>
    <div class="fup-button__container">
        <!-- <div class="teste__botao" id="link-button">
          +
        </div> -->
        <div @click="openNewFollowUp" class="teste__botao" :id="`inactive-popover${task.id}`">+
        </div>
        <b-popover
          :target="`popover${task.id}`"
          triggers="focus blur"
          placement="top"
          custom-class="fup-button__popover__container"
          >
          <!-- triggers="click" -->
          <slot name="title">
            <DefaultButton
            :onClick="openNewFollowUp"
            btnVariant="btn-fifth"
            icon="fas fa-plus"
            text="NOVO follow-up"
            />
            <div style="height: 1rem;"></div>
          </slot>
          <slot name="default">
            <div class="fup-button__popover__body">
              <CrmDetailsTimeline
              ref="CrmDetailsTimeline"
              v-if="true"
              :card="task"
              v-on:Reload="onReloadBoardAndFollowUp"
              />
            </div>
          </slot>
          <!-- <DetailContainer
              :defaultOpen="true"
              componentTitle="Atividades"
              componentIcon="fas fa-undo"
              :customActionIcon="cardActive ? 'fas fa-plus-circle' : ''"
              :customActionFunction="cardActive ? openNewFollowUp : null"
            >

            </DetailContainer> -->
        </b-popover>
        <!-- <b-tooltip target="link-button" title="Tooltip title" triggers="focus">
        Tooltip title
        </b-tooltip> -->
      <ModalNewFollowUp
        v-if="openFollowUpModal"
        ref="ModalNewFollowUp"
        :card="task"
        v-on:Reload="closeNewFollowUp"
      />
    </div>
</template>
<script>
import DetailContainer from '@/views/private/crm/components/detailContainer/detailContainer.vue'
import CrmDetailsTimeline from '@/views/private/crm/details/timeline/timeline.vue'
import ModalNewFollowUp from '@/views/private/crm/details/followup/followup.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'NxFupButton',
  data () {
    return {
      example: 'JAN 27, 15:50',
      openFollowUpModal: false
    }
  },
  components: { DetailContainer, CrmDetailsTimeline, ModalNewFollowUp, DefaultButton },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    cardActive () {
      return this.task && this.task.situacao === 'ATIVO' && !this.task.boardColumn.board.arquivado
    }
  },
  methods: {
    openNewFollowUp () {
      this.openFollowUpModal = true
    },
    closeNewFollowUp () {
      this.openFollowUpModal = false
      this.onReloadBoardAndFollowUp()
      // this.onReloadFollowup()
    },
    onReloadBoardAndFollowUp () {
      console.log('onReloadBoardAndFollowUp')
    }
  }
}
</script>
<style lang="scss">
.fup-button {
    &__container{
        width: 26px;
        height: 26px;
        color: white;
        background: #6940AB !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 4px;
    }
}
.fup-button__popover__body{
    height: 35vh;
    overflow-y: scroll;

    @media screen and (max-width: 420px) {
      height: 50vh;
  }
}
.fup-button__popover__container{
  font-size: 10px;
  width: 40vw;
  max-width: 35rem;

  @media screen and (max-width: 420px) {
    width: 95vw;
  }
  .tab-pane.active.card-body{
    padding: 0;
  }
  .timeline{
    .timeline-type{
      padding: 8px .8rem !important;
      min-width: fit-content !important;
    }
  }
  .px-4.pb-2{
    padding: 0 12px !important;
  }
  .d-flex.justify-content-between{
    gap: .8rem;
  }
  .d-flex.flex-column.justify-content-center.pr-4.w-100{
    padding-right: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/buttons/NxFupButton.vue